import CustomMarkDownArea from "components/base/CustomMarkDownArea";
import i18n from "I18n";
import React from "react";
import { useFormContext } from "react-hook-form";

const ReactHookFormMarkDownArea = ({
  areaTitle,
  titleConfig = {
    label: "",
    valueFieldName: "",
    disableFocusChange: false,
    focusChangeKey: "",
    tips: {},
  },
  contentConfig = {
    label: "",
    valueFieldName: "",
    disableFocusChange: false,
    focusChangeKey: "",
    tips: {},
  },
  hasTranslation = false,
  focusChange = () => { },
  language,
}) => {
  const { watch, setValue } = useFormContext();
  const displayAreaTitle = hasTranslation ? i18n.t(areaTitle, { locale: language }) : areaTitle;
  const displayTitleLabel = hasTranslation ? i18n.t(titleConfig?.label, { locale: language }) : titleConfig?.label;
  const displayContentLabel = hasTranslation ? i18n.t(contentConfig?.label, { locale: language }) : contentConfig?.label;

  const titleValueFieldName = hasTranslation && titleConfig?.valueFieldName
    ? titleConfig.valueFieldName.replace("{{language}}", language) : titleConfig?.valueFieldName

  const contentValueFieldName = hasTranslation && contentConfig?.valueFieldName
    ? contentConfig.valueFieldName.replace("{{language}}", language) : contentConfig?.valueFieldName
  const watchTitle = watch(titleValueFieldName)
  const watchContent = watch(contentValueFieldName)

  const focusChangeActionByConfig = (config) => {
    if (config?.disableFocusChange) {
      return
    }
    const { focusChangeKey } = config
    focusChange(focusChangeKey || config?.valueFieldName)
  }

  return (
    <CustomMarkDownArea
      areaTitle={displayAreaTitle}
      title={{
        label: displayTitleLabel,
        value: watchTitle,
        valueChange: (value) => {
          setValue(titleValueFieldName, value, { shouldDirty: true })
        },
        tips: { ...titleConfig?.tips || {} },
        focus: () => {
          focusChangeActionByConfig(titleConfig)
        }
      }}
      content={{
        label: displayContentLabel,
        value: watchContent,
        valueChange: (value) => {
          setValue(contentValueFieldName, value, { shouldDirty: true })
        },
        tips: { ...titleConfig?.tips || {} },
        focus: () => {
          focusChangeActionByConfig(contentConfig)
        }
      }}
    />
  );
}

export default ReactHookFormMarkDownArea;